// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
 
 
 
 
 
import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';

import CardsReportsPage from './CardsReportsPage';

const CardsReports: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasCardsReportsAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'CardsReports')
  );

  return (
    <CardContainer>
      <Switch>

        <Route exact path={`${baseURL}`}>
          <CardsReportsPage/>
        </Route>

      </Switch>
    </CardContainer>
  );
};

export { CardsReports };
